import React from "react";
import useRevealOnScroll from "../hooks/useRevealOnScroll";
import { useLanguage } from "../context/LanguageContext";
import translations from "../i18n/translations";

function CallToAction() {
  const email = "josuerushanika@gmail.com";
  const { elementRef, isVisible } = useRevealOnScroll();
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section
      ref={elementRef}
      className={`px-6 py-16 md:px-16 lg:px-28 ${
        isVisible ? "animate-fade-in-up" : ""
      }`}
    >
      <div className="mx-auto max-w-6xl rounded-2xl bg-gradient-to-r from-blue-600/80 via-coding-color/80 to-emerald-500/80 p-[1px] animate-pulse-soft">
        <div className="flex flex-col items-start gap-6 rounded-2xl bg-gray-900 px-6 py-8 md:flex-row md:items-center md:justify-between md:px-10">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-coding-color">
              {t.callToAction.eyebrow}
            </p>
            <h2 className="mt-3 text-2xl font-bold text-white md:text-3xl">
              {t.callToAction.title}
            </h2>
            <p className="mt-3 max-w-xl text-sm text-gray-300">
              {t.callToAction.body}
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            <a
              href={`mailto:${email}?subject=Let%27s%20work%20together`}
              className="rounded-full bg-blue-500 px-6 py-2 text-sm font-semibold text-white transition hover:bg-blue-600"
            >
              {t.callToAction.emailMe}
            </a>
            <a
              href="#projects"
              className="rounded-full border border-blue-400 px-6 py-2 text-sm font-semibold text-blue-100 transition hover:bg-blue-500/10"
            >
              {t.callToAction.viewProjects}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CallToAction;
